module.exports = __webpack_public_path__ + "static/media/sadCat.367449d5.jpg";